import { useDebugValue } from 'react';
import { CONDITIONS_LIMIT } from '../../../constants';
import { useClauseConditionsWatch } from '../watchers/useClauseConditionsWatch';

export const useHasMaximumConditions = () => {
  const hasMaximumConditions = useClauseConditionsWatch().length >= CONDITIONS_LIMIT;
  useDebugValue(hasMaximumConditions);
  return hasMaximumConditions;
};
